const namespaced = true;

const getInitialState = () => {
    return {
        addresses: [],
        selectedAddress: null
    };
};

const state = getInitialState();

const getters = {
    addresses: state => state.addresses,
    selectedAddress: state => state.selectedAddress
};

const mutations = {
    ADD_ADDRESS: (state, payload) => {
        state.addresses = [...state.addresses, payload];
    },
    SET_ADDRESSES: (state, payload) => {
        state.addresses = payload;
    },
    REMOVE_ADDRESS_BY_ID: (state, payload) => {
        state.addresses = state.addresses.filter(address => address.id !== payload);
    },
    EDIT_ADDRESS: (state, payload) => {
        const addressIndex = state.addresses.findIndex(address => address.id === payload.id);

        state.addresses[addressIndex] = payload;

        state.addresses = [ ...state.addresses ];
    },

    SET_SELECTED_ADDRESS: (state, payload) => {
        state.selectedAddress = payload;
    },
    RESET_STATE: state => {
        Object.assign(state, getInitialState());
    }
};

const actions = {
    GET_ADDRESSES: async context => {
        try {
            const response = await window.api.call('get-addresses');
            const addresses = response.data.data || [];

            context.commit('SET_ADDRESSES', addresses);

            const selected = context.rootState.boxes?.selectedDeliveryAddress;
            const hasSelected = !!selected?.id;
            const selectedStillExists = hasSelected
                ? addresses.some(address => address.id === selected.id)
                : false;

            // Keep current selection if it still exists; otherwise choose the newest address.
            if (!selectedStillExists) {
                const nextAddress = addresses
                    .slice()
                    .sort((a, b) => {
                        const aTs = getAddressTimestamp(a);
                        const bTs = getAddressTimestamp(b);
                        return bTs - aTs;
                    })[0] || null;

                context.commit('boxes/SET_DELIVERY_ADDRESS', nextAddress, { root: true });
            }

            return addresses;
        } catch (error) {
            console.error('Error fetching addresses:', error);

        }
    },

    GET_ADDRESSES_SUGGESTIONS: async context => {
        const response = await window.api.call('get-addresses-suggestions');

        context.commit('SET_ADDRESSES', response.data.data);

        return response.data.data;
    },
    DELETE_ADDRESS: async (context, payload) => {
        const response = await window.api.call('delete-address', { id: payload });

        context.commit('REMOVE_ADDRESS_BY_ID', payload);

        return response.data.data;
    }
};

function getAddressTimestamp(addr) {
    const raw = addr?.created_at || addr?.createdAt || addr?.created || addr?.dateCreated || addr?.date_created || '';
    if (!raw) {
        return 0;
    }
    const normalized = typeof raw === 'string' ? `${raw.replace(' ', 'T')}Z` : raw;
    const timestamp = new Date(normalized).getTime();
    return Number.isFinite(timestamp) ? timestamp : 0;
}

export default {
    namespaced,
    state,
    mutations,
    actions,
    getters
};
